import { ApplicationConfig } from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { httpInterceptor } from "./interceptors/http.interceptor";
import { provideLuxonDateAdapter } from "@angular/material-luxon-adapter";
import { provideToastr } from "ngx-toastr";
import { provideLuxonDateAdapterOptions } from "./providers/luxon-options-provider";
import {
    provideTippyLoader,
    provideTippyConfig,
    tooltipVariation,
    popperVariation,
} from "@ngneat/helipopper/config";

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideHttpClient(withInterceptors([httpInterceptor])),
        provideAnimationsAsync(),
        provideLuxonDateAdapter(),
        provideLuxonDateAdapterOptions(),
        provideToastr({ positionClass: "toast-bottom-right", timeOut: 1500 }),
        provideTippyLoader(() => import("tippy.js")),
        provideTippyConfig({
            defaultVariation: "tooltip",
            variations: {
                tooltip: tooltipVariation,
                popper: popperVariation,
            },
        }),
    ],
};
